// Angular
import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { AnimationBuilder, AnimationPlayer } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';
// RxJS
import { Subscription } from 'rxjs';
import { AppRouteNames } from 'src/app/app-paths.constants';
import { RouteChangeAnimation } from 'src/app/rek-client-app/shared/animations/route-change.animation';

@Directive({
  selector: '[ktContentAnimate]'
})
export class ContentAnimateDirective implements OnInit, OnDestroy {
  player: AnimationPlayer;

  private events: Subscription;

  constructor(
    private el: ElementRef,
    private router: Router,
    private animationBuilder: AnimationBuilder) {
  }

  ngOnInit(): void {
    // animate the content
    this.initAnimate();
    // animate page load
    this.events = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd && !event.url.includes(AppRouteNames.App.Dashboard.Root)) {
        this.player.play();
      }
    });
  }

  ngOnDestroy(): void {
    this.events.unsubscribe();
    this.player.destroy();
  }

  initAnimate() {
    this.player = this.animationBuilder
      .build(RouteChangeAnimation)
      .create(this.el.nativeElement);
  }
}
